<template>
  <div class="p-5 layout-container">
    <v-card class="p-5 no-print-card" flat>
      <v-row class="pb-0 pt-4">
        <!-- ستون سمت چپ: پیش‌نمایش -->
        <v-col cols="12" md="7" class="preview-col">
          <div class="d-flex justify-space-between align-center mb-4 no-print">
            <h3 style="color: #001554">پیش‌نمایش چیدمان</h3>

            <div>
              <LayoutExportModal
                target-id="print-layout-container"
                :is-transparent="settings.isPageTransparent"
                :disabled="localQrList.length === 0"
                
              />
            </div>
          </div>

          <v-alert
            v-if="localQrList.length === 0"
            color="#022B3B3A"
            type="info"
            dense
            border="left"
            colored-border
          >
            لطفاً چندین عکس (کیوآرکد) را برای چیدمان انتخاب کنید.
          </v-alert>

          <!-- پس‌زمینه شطرنجی -->
          <div v-else class="layout-wrapper-scroll checkerboard-bg">
            <div
              id="print-layout-container"
              class="print-layout-container"
              :style="pageStyle"
            >
              <div
                v-for="(qr, index) in layoutItems"
                :key="index"
                :style="qrBoxStyle"
              >
                <img
                  v-if="qr.url"
                  :src="qr.url"
                  alt="QR"
                  :style="qrImageStyle"
                  crossorigin="anonymous"
                />
                <slot v-else name="qr-content" :qr="qr"></slot>
              </div>
            </div>
          </div>
        </v-col>

        <!-- ستون سمت راست: تنظیمات و آپلود -->
        <v-col cols="12" md="5" class="no-print">
          <p class="font-weight-bold mb-4 text-right" style="color: #001554">
            <v-icon color="warning" class="me-2">mdi-cogs</v-icon>
            تنظیمات چیدمان و صفحه
          </p>
          <v-expansion-panels
            v-model="activePanels"
            accordion
            flat
            class="px-2"
          >
            <v-expansion-panel class="mb-4">
              <v-expansion-panel-header class="text-right">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <v-icon color="primary" class="me-2"
                      >mdi-image-multiple</v-icon
                    >
                    <span style="font-weight: bold"
                      >انتخاب عکس‌های کیوآرکد</span
                    >
                  </div>
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="py-5">
                <v-card outlined class="mb-4 pa-3" color="#f8f9fa">
                  <!-- انتخاب منبع فایل -->
                  <v-select
                    v-model="selectedSource"
                    :items="sourceOptions"
                    item-text="text"
                    item-value="value"
                    label="انتخاب روش افزودن تصویر"
                    outlined
                    dense
                    color="primary"
                    class="mb-3 font-weight-bold"
                    hide-details
                  ></v-select>

                  <v-divider class="mb-4"></v-divider>

                  <!-- نمایش تعداد فایل‌های آماده -->
                  <div
                    v-if="localQrList.length > 0"
                    class="text-center mb-3 font-weight-bold"
                    style="color: #001554"
                  >
                    <v-icon color="primary" small class="me-1"
                      >mdi-file-document-multiple</v-icon
                    >
                    {{ localQrList.length }} عکس برای چیدمان آماده است
                  </div>

                  <!-- حالت ۱: آپلودسنتر -->
                  <template v-if="selectedSource === 'uploadCenter'">
                    <PicSelector
                      v-model="picSelectorData"
                      :edit-name="false"
                      single
                      default-cat-name="Layout"
                    />
                  </template>

                  <!-- حالت ۲: فایل لوکال -->
                  <template v-if="selectedSource === 'local'">
                    <local-image-uploader
                      v-model="localFilesData"
                      @input="extractLocalImages"
                    />
                  </template>

                  <!-- حالت ۳: دیجی‌کالا -->
                  <template v-if="selectedSource === 'digikala'">
                    <v-alert
                      border="left"
                      color="success"
                      colored-border
                      class="white elevation-1"
                    >
                      این فایل را داخل Tampermonkey قرار دهید:
                      <a
                        href="js/Digikala Image Collector-1.0.user.js"
                        style="
                          text-decoration: none;
                          color: #4caf50;
                          font-weight: bold;
                        "
                      >
                        دانلود فایل
                      </a>
                    </v-alert>

                    <div
                      class="text-right mb-2 font-weight-bold"
                      style="color: #001554"
                    >
                      <v-icon color="primary" small class="me-1"
                        >mdi-link</v-icon
                      >
                      وارد کردن لینک از دیجی‌کالا
                    </div>
                    <v-textarea
                      v-model="digikalaLinks"
                      outlined
                      dense
                      rows="3"
                      placeholder="کد کپی شده از دیجی‌کالا را اینجا Paste کنید..."
                      hide-details
                      class="mb-3"
                    ></v-textarea>
                    <v-btn
                      class="btn-get-code rounded-lg mx-0"
                      block
                      @click="importDigikalaLinks"
                      ><v-icon left>mdi-plus</v-icon>
                      اضافه کردن به لیست چیدمان
                    </v-btn>
                  </template>

                  <div v-if="isLoadingFiles" class="text-center mt-2">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="24"
                    ></v-progress-circular>
                    <span class="ms-2 text-caption"
                      >در حال خواندن عکس‌ها...</span
                    >
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel class="mb-4">
              <v-expansion-panel-header class="text-right">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <v-icon color="primary" class="me-2">mdi-image-edit</v-icon>
                    <span style="font-weight: bold"
                      >مدیریت و ویرایش عکس‌ها</span
                    >
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="py-5">
                <image-editor-list v-model="localQrList"></image-editor-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- تنظیمات صفحه -->
            <v-expansion-panel class="mb-4">
              <v-expansion-panel-header class="text-right">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <v-icon color="primary" class="me-2"
                      >mdi-file-document-outline</v-icon
                    >
                    <span style="font-weight: bold">تنظیمات صفحه اصلی</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="py-5">
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model.number="settings.pageWidth"
                      label="عرض صفحه (mm)"
                      type="number"
                      :rules="[rules.required, rules.positive]"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model.number="settings.pageHeight"
                      label="طول صفحه (mm)"
                      type="number"
                      :rules="[rules.required, rules.positive]"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.paddingTop"
                      label="حاشیه بالا (mm)"
                      type="number"
                      :rules="[rules.required, rules.nonNegative]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.paddingBottom"
                      label="حاشیه پایین (mm)"
                      type="number"
                      :rules="[rules.required, rules.nonNegative]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.paddingLeft"
                      label="حاشیه چپ (mm)"
                      type="number"
                      :rules="[rules.required, rules.nonNegative]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.paddingRight"
                      label="حاشیه راست (mm)"
                      type="number"
                      :rules="[rules.required, rules.nonNegative]"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-switch
                      v-model="settings.isPageTransparent"
                      label="پس‌زمینه کل صفحه شفاف باشد (برای PNG)"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- تنظیمات کیوآرکد (با اعمال Rules) -->
            <v-expansion-panel class="mb-4">
              <v-expansion-panel-header class="text-right">
                <div class="d-flex justify-space-between align-center">
                  <div>
                    <v-icon color="primary" class="me-2">mdi-qrcode</v-icon>
                    <span style="font-weight: bold">تنظیمات کیوآرکدها</span>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="py-3">
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.copies"
                      label="تعداد کپی هر کیوار"
                      type="number"
                      :rules="[rules.required, rules.minOne]"
                      min="1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.qrSize"
                      label="ابعاد کیوار (mm)"
                      type="number"
                      :rules="[rules.required, rules.positive]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.qrGap"
                      label="فاصله بین کیوآرها (mm)"
                      type="number"
                      :rules="[rules.required, rules.nonNegative]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      v-model.number="settings.qrPadding"
                      label="حاشیه داخلی باکس (mm)"
                      type="number"
                      :rules="[rules.required, rules.nonNegative]"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-slider
                      v-model="settings.borderRadius"
                      label="گردی لبه عکس‌ها (mm)"
                      max="20"
                      min="0"
                      thumb-label
                      hide-details
                      class="mb-3"
                    ></v-slider>
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      v-model="settings.isQrTransparent"
                      label="پس‌زمینه کیوآر شفاف باشد"
                      color="primary"
                      hide-details
                      class="mb-2"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" v-if="!settings.isQrTransparent">
                    <span class="text-caption d-block mb-1"
                      >رنگ پس‌زمینه کیوآرکد:</span
                    >
                    <color-picker
                      v-model="settings.qrBackgroundColor"
                      :label="$t('color')"
                      size="100%"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-switch
                      v-model="settings.hasQrBorder"
                      label="کادر دور کیوآر داشته باشد"
                      color="primary"
                      hide-details
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import LayoutExportModal from "./LayoutExportModal.vue";
import html2canvas from "html2canvas";
import PicSelector from "@/view/components/UploadCenter/picSelector";
import ColorPicker from "@/view/pages/qrland/components/colorPicker";
import LocalImageUploader from "./LocalImageUploader.vue";
import ImageEditorList from "./ImageEditorList.vue";
import { writePsd } from "ag-psd";
import JSZip from "jszip";
import { saveAs } from "file-saver";


export default {
  name: "QrLayoutBuilder",
  components: {
    PicSelector,
    ColorPicker,
    LocalImageUploader,
    ImageEditorList,
    LayoutExportModal,
  },
  props: {
    // show: { type: Boolean, default: true },
    qrList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedSource: "local",
      sourceOptions: [
        { text: "آپلود فایل از سیستم", value: "local" },
        { text: "انتخاب از آپلودسنتر", value: "uploadCenter" },
        { text: "وارد کردن از دیجی‌کالا", value: "digikala" },
      ],
      digikalaLinks: "",
      activePanels: [0, 1],
      isExporting: false,
      isLoadingFiles: false,
      localQrList: [],
      useUploadCenter: true,
      picSelectorData: [{ name: "", images: [] }],
      localFilesData: [],

      rules: {
        required: (v) =>
          (v !== "" && v !== null && v !== undefined) || "الزامی است",
        positive: (v) => v > 0 || "باید بزرگتر از ۰ باشد",
        nonNegative: (v) => v >= 0 || "نمی‌تواند منفی باشد",
        minOne: (v) => v >= 1 || "حداقل ۱ باشد",
      },

      settings: {
        pageWidth: 580,        // عرض صفحه
        pageHeight: 100,       // طول صفحه
        paddingTop: 0,         // حاشیه بالا
        paddingBottom: 0,      // حاشیه پایین
        paddingLeft: 0,        // حاشیه چپ
        paddingRight: 0,       // حاشیه راست
        isPageTransparent: true,
        copies: 1,             // تعداد کپی 
        qrSize: 24,            // ابعاد کیوآر 
        qrGap: 2,              // فاصله بین کیوآرها 
        qrPadding: 0,          // حاشیه داخلی 
        borderRadius: 6,       // گردی لبه عکس‌ها - پیش فرض 6 
        isQrTransparent: true,
        qrBackgroundColor: "#ffffff",
        hasQrBorder: false,
      },
    };
  },
  watch: {
    picSelectorData: {
      deep: true,
      handler(newVal) {
        this.extractImages(newVal);
      },
    },
    qrList: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.localQrList = [...val];
        }
      },
    },
    useUploadCenter() {
      this.localQrList = [];
      this.picSelectorData = [{ name: "", images: [] }];
      this.localFilesData = [];
    },
  },
  computed: {
    layoutItems() {
      let items = [];
      this.localQrList.forEach((qr) => {
        for (let i = 0; i < this.settings.copies; i++) {
          items.push(qr);
        }
      });
      return items;
    },
    pageStyle() {
      return {
        width: `${this.settings.pageWidth}mm`,
        minHeight: `${this.settings.pageHeight}mm`,
        paddingTop: `${this.settings.paddingTop}mm`,
        paddingBottom: `${this.settings.paddingBottom}mm`,
        paddingLeft: `${this.settings.paddingLeft}mm`,
        paddingRight: `${this.settings.paddingRight}mm`,
        display: "flex",
        flexWrap: "wrap",
        alignContent: "flex-start",
        justifyContent: "flex-start",
        backgroundColor: this.settings.isPageTransparent
          ? "transparent"
          : "#ffffff",
        boxSizing: "border-box",
      };
    },
    qrBoxStyle() {
      return {
        width: `${this.settings.qrSize}mm`,
        height: `${this.settings.qrSize}mm`,
        margin: `${this.settings.qrGap / 2}mm`,
        padding: `${this.settings.qrPadding}mm`,
        borderRadius: `${this.settings.borderRadius}mm`,
        backgroundColor: this.settings.isQrTransparent
          ? "transparent"
          : this.settings.qrBackgroundColor,
        border: this.settings.hasQrBorder ? "1px solid #000000" : "none",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      };
    },
    qrImageStyle() {
      return {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        display: "block",
        borderRadius: `${this.settings.borderRadius}mm`, 
        overflow: "hidden",

      };
    },
  },
  methods: {
    importDigikalaLinks() {
      if (!this.digikalaLinks) return;
      try {
        const parsedUrls = JSON.parse(this.digikalaLinks);

        if (Array.isArray(parsedUrls)) {
          const mappedUrls = parsedUrls.map((url) => ({ url: url }));

          this.localQrList = [...this.localQrList, ...mappedUrls];

          this.digikalaLinks = "";
          this.$toast.success("عکس‌ها با موفقیت اضافه شدند!");
        }
      } catch (error) {
        console.error("خطا در پردازش لینک‌ها:", error);
        this.$toast.error(
          "فرمت لینک‌های وارد شده نامعتبر است. لطفاً مستقیماً از اسکریپت دیجی‌کالا کپی کنید.",
        );
      }
    },
    extractImages(galleries) {
      this.isLoadingFiles = true;
      try {
        let allImages = [];
        if (galleries && galleries.length) {
          galleries.forEach((gallery) => {
            if (gallery.images && gallery.images.length) {
              allImages.push(...gallery.images);
            }
          });
        }
        this.localQrList = allImages
          .map((img) => {
            if (img && img.url) {
              return { url: img.url };
            }
            return null;
          })
          .filter((item) => item !== null);
      } catch (error) {
        console.error("خطا در استخراج عکس‌ها :", error);
      } finally {
        this.isLoadingFiles = false;
      }
    },
    extractLocalImages(files) {
      if (!files) return;
      this.localQrList = files.map((fileData) => {
        return { url: fileData.url };
      });
    },

    readFileAsDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
      });
    },
    async downloadAsPNG() {
      if (this.localQrList.length === 0) return;
      this.isExporting = true;

      try {
        const layoutElement = document.getElementById("print-layout-container");

        const canvas = await html2canvas(layoutElement, {
          useCORS: true,
          allowTaint: false,
          scale: 3,
          backgroundColor: this.settings.isPageTransparent ? null : "#ffffff",
        });

        const pngDataUrl = canvas.toDataURL("image/png", 1.0);

        const link = document.createElement("a");
        link.download = `QR-Layout-${new Date().getTime()}.png`;
        link.href = pngDataUrl;
        link.click();
      } catch (error) {
        console.error("خطا در تولید عکس:", error);
        this.$toast.error("مشکلی در تولید عکس با html2canvas به وجود آمد.");
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>

<style scoped>
.checkerboard-bg {
  background-color: #e5e5f7;
  opacity: 1;
  background-image: repeating-linear-gradient(
      45deg,
      #c4c4c4 25%,
      transparent 25%,
      transparent 75%,
      #c4c4c4 75%,
      #c4c4c4
    ),
    repeating-linear-gradient(
      45deg,
      #c4c4c4 25%,
      #e5e5f7 25%,
      #e5e5f7 75%,
      #c4c4c4 75%,
      #c4c4c4
    );
  background-position: 0 0, 10px 10px;
  background-size: 20px 20px;
}

.layout-wrapper-scroll {
  width: 100%;
  max-height: 600px;
  overflow: auto;
  border: 2px dashed #999;
  padding: 10px;
  border-radius: 8px;
}

.print-layout-container {
  box-sizing: border-box;
  margin: 0 auto;
  transform-origin: top center;
  zoom: 0.6;
}

@media print {
  body * {
    visibility: hidden;
  }

  .no-print,
  .no-print * {
    display: none !important;
  }

  .print-layout-container,
  .print-layout-container * {
    visibility: visible;
  }

  .print-layout-container {
    position: absolute;
    left: 0;
    top: 0;
    margin: 0;
    padding: 0;
    zoom: 1 !important;
  }

  @page {
    size: auto;
    margin: 0;
  }
}
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}
.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}
.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}
.submit-btn {
  border-radius: 10px;
  font-weight: bold;
}
.file-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid transparent;
}
.file-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  border-color: #e0e0e0;
}
.selected-card {
  background-color: #f0f7ff !important;
  border: 1px solid #1976d2 !important;
}
.file-name {
  color: #333;
  font-weight: 500;
}
</style>
